import main from "./mainTheme";

// Mesma paleta do tema claro, com a cor da marca clareada para manter contraste
// sobre fundos escuros.
const darkTheme = {
  ...main,
  primary: "#9d6bdf",
  secondary: "#9d6bdf",
  success: "#9d6bdf",
  rufous: "#7c83f0",
  blue: "#7c83f0",
  white: "#fff",
};

export default darkTheme;
